import { render, staticRenderFns } from "./NewsDetailContainer.vue?vue&type=template&id=819d0976&scoped=true&"
import script from "./NewsDetailContainer.vue?vue&type=script&lang=js&"
export * from "./NewsDetailContainer.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetailContainer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NewsDetailContainer.vue?vue&type=style&index=1&id=819d0976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819d0976",
  null
  
)

export default component.exports